import {uuid} from 'vue-uuid';
import { createNamespacedHelpers } from 'vuex';
const authMapper = createNamespacedHelpers('global/auth');
const modelMapper = createNamespacedHelpers('detector/model');
export default {
	computed: {
		...modelMapper.mapState(['model']),
		...authMapper.mapState(['username']),
	},
    methods: {
		/**
		 * start running the camera
		 * @param {string} camera: the camera mode name
		 */
		openCamera(mode, cameraId) {
			navigator.mediaDevices
				.getUserMedia({
					video: {
						deviceId: cameraId || null,
						facingMode: mode,
					},
					audio: false,
				})
				.then((stream) => {
					this.stream = stream;

					this.$refs.camera.srcObject = stream;

					this.$refs.camera.play();
				})
				.catch((error) => {
					console.error(`We have met the error: ${error}`);
				});
		},
		closeCamera() {
			let tracks = this.$refs.camera.srcObject.getTracks();

			tracks.forEach((track) => {
				track.stop();
			});
		},
		/**
		 * live captured image convert to binary
		 */
		async convertImageToBinary(uri) {
			if (uri === '') return;
			const creatAt = new Date()

			let file = await this.convertDataURItoBlob(uri);

			let type = file.type.split('/')[1];

			if (window.location.hash === "#/camera") {
				file.name = this.username+"_"+this.model.replace(".pytorch","")+"_"+creatAt.getTime()+ '.' + type				
			}else if(window.location.hash === "#/trainer"){
				file.name = this.username+"_"+creatAt.getTime() + '.' + type;

			}

			return file;
		},
		/**
		 * convert base64/URLEncoded data component to raw binary data held in a string
		 * @param {String} dataURI: base64/URLEncoded data
		 */
		async convertDataURItoBlob(dataURI) {
			let byteString;

			if (dataURI.split(',')[0].indexOf('base64') >= 0) {
				byteString = atob(dataURI.split(',')[1]);
			} else {
				byteString = dataURI.split(',')[1];
			}
			// separate out the MIME type
			let mimeString = dataURI
				.split(',')[0]
				.split(':')[1]
				.split(';')[0];

			let ia = new Uint8Array(byteString.length);

			for (let i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}
			return new Blob([ia], { type: mimeString });
		},

    },

  };
  